module.exports = __webpack_public_path__ + "static/media/pic_empty_scanteams.933ee366.svg";